package com.exura.features.firebase.di

import com.exura.features.firebase.usecase.GetUserDataPrefixUseCase
import com.exura.features.firebase.usecase.GetUserFilesPrefixUseCase
import org.koin.dsl.module

val firebaseModule = module {
    factory<GetUserDataPrefixUseCase> { GetUserDataPrefixUseCase(get(), get()) }
    factory<GetUserFilesPrefixUseCase> { GetUserFilesPrefixUseCase(get(), get()) }
}
